import {useEffect, useState} from 'react'

import useIsMobile from './useIsMobile'
import useReducedMotion from './useReducedMotion'

const useParallaxEnabled = () => {
  const isMobile = useIsMobile()
  const prefersReducedMotion = useReducedMotion()
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    if (isMobile || prefersReducedMotion) {
      setEnabled(false)

      return
    }

    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      setEnabled(false)

      return
    }

    setEnabled(true)
  }, [isMobile, prefersReducedMotion])

  return enabled
}

export default useParallaxEnabled
